export const getSourcesNumber = (horizontalMenu, verticalMenu, bookmarksMenu) =>
	horizontalMenu.length + verticalMenu.length + bookmarksMenu.length;

export const getSourceNumber = (source, activeTab, sourceType) =>
	source.length > 0 && activeTab !== sourceType ? `(${source.length})` : null;
